import { HttpErrorResponse } from '@angular/common/http';

export class ApiResponse<T = null> {
  code: string = '';
  message: string = '';
  data?: T;

  // get message(): string {
  //   return this._message;
  // }

  // set message(value: string) {
  //   this._message = value;
  // }

  constructor(error?: HttpErrorResponse) {
    if (!error) return;

    if (error instanceof HttpErrorResponse) {
      const err = error.error ?? error;
      this.message =
        'message' in err ? err.message : `${error.status} ${error.name}`;
      this.code = 'code' in err ? err.code : '';
    }
  }
}
